import { useEffect, useState } from 'react'
import { TextField } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'

/**
 * Dialog used to skip (omit) a JOB node, offering an OPTIONAL reason (S26/RN3).
 * @param {Object} props Props object
 * @param {boolean} props.open Variable to control dialog visibility
 * @param {Function} props.onClose Function to close the dialog
 * @param {function(string)} props.onAccept Function to execute with the (possibly empty) reason on accept
 * @returns
 */
const SkipNodeDialog = ({ open, onClose, onAccept }) => {
  const { t_ } = useSmartTranslation()
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (!open) {
      setReason('')
    }
  }, [open])

  const handleAccept = () => {
    onAccept(reason)
    onClose()
  }

  return (
    <SmartDialog
      setOpen={open}
      title={t_('Skip')}
      accept
      acceptCallback={handleAccept}
      cancelCallback={onClose}
      renderComponent={
        <TextField
          fullWidth
          multiline
          label={t_('Reason (optional)')}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
      }
    />
  )
}

export default SkipNodeDialog
